export default "__VITE_ASSET__91a6bd1f__"